// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🔹 Navbar com fundo azul escuro */
.custom-navbar {
  background-color: #ff7e00 !important;
  padding: 10px 0;
}

/* 🔹 Ajuste do Logo */
.navbar-logo {
  width: 100px;  /* Reduzido para um tamanho ideal */
  height: auto;
  display: block;
  object-fit: contain;
}



/* 🔹 Marca da Mobili */
.navbar-brand {
  font-size: 1.5rem;
  font-weight: bold;
  color: #00D4FF !important; /* Azul claro do logo */
}

/* 🔹 Links do menu */
.nav-link {
  color: #FFFFFF !important;
  font-size: 1.1rem;
  margin-right: 15px;
}

/* 🔹 Efeito ao passar o mouse */
.nav-link:hover {
  color: #00D4FF !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,YAAY,GAAG,mCAAmC;EAClD,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;;;AAIA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B","sourcesContent":["/* 🔹 Navbar com fundo azul escuro */\n.custom-navbar {\n  background-color: #ff7e00 !important;\n  padding: 10px 0;\n}\n\n/* 🔹 Ajuste do Logo */\n.navbar-logo {\n  width: 100px;  /* Reduzido para um tamanho ideal */\n  height: auto;\n  display: block;\n  object-fit: contain;\n}\n\n\n\n/* 🔹 Marca da Mobili */\n.navbar-brand {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #00D4FF !important; /* Azul claro do logo */\n}\n\n/* 🔹 Links do menu */\n.nav-link {\n  color: #FFFFFF !important;\n  font-size: 1.1rem;\n  margin-right: 15px;\n}\n\n/* 🔹 Efeito ao passar o mouse */\n.nav-link:hover {\n  color: #00D4FF !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
